<script>
export default {
  name: "dol-mind",
  render: function (createElement) {
    let data = this.treeData || [];

    let children = [];
    data.forEach(d => {
      let renderNode;
      if(typeof this.$scopedSlots.default === 'function'){
        renderNode = [this.$scopedSlots.default];
      }else if(typeof this.$slots.default){
        renderNode = this.$slots.default;
      }

      children.push(createElement('dol-mind-node', {props:{data: d, borderFlag:this.borderFlag, padding: this.padding}}, renderNode));
    });


    return createElement(
        'div',
        {
          class:'dol-mind'
        },
        children
    );
  },
  props: {
    data:{},

    source: { type: String, default: 'server' },            //数据源，server | local
    //---------------------- if source === server --------------------------------//
    url: { type: String },                                  //后台地址
    method: { type: String, default: 'get' },              //请求方式
    queryParams: { type: Object, default: () => {} },             //请求参数
    initDataFlag: { type: Boolean, default: true },         //默认是否请求一次数据
    //---------------------- if source === local  --------------------------------//
    defaultData: { type: Array, default: () => [] },                     //后台地址

    loading: {type: Boolean, default: true},
    nodeKey: {type: String, default: '_id'},
    borderFlag:{type: Boolean, default: true},
    padding:{type: String, default: '10px'},
  },

  data(){
    return {
      serverData: [],
      loadingFlag: false,
    };
  },
  computed:{
    treeData(){
      let data = [];
      switch (this.source) {
        case 'server':
          data = this.serverData;
          break;
        case 'local':
          data = this.defaultData;
          break;
      }
      return data;
    }
  },
  methods:{
    query: function () {
      if(this.source === 'server'){
        let url = this.url;
        this.loadingFlag = true;
        this.$ajax({
          url:url,
          method:this.method,
          params: this.queryParams,
          loading: true,
        }).then((data) => {
          this.loadingFlag = false;
          this.serverData = data.rows;
          console.log(data.rows);

          setTimeout(() => {
            this.$emit('finished', data);
          }, 200);
        }).catch(() => {
          this.loadingFlag = false;
        });
      }
    },
    currentChange: function (data, node) {
      this.$emit('current-change', data, node);
    },
    nodeClick: function (data, node, tree) {
      this.$emit('node-click', data, node, tree);
    },
  },
  created() {
    if(this.source === 'server'){
      if(this.initDataFlag){
        this.query();
      }
    }
  }
}
</script>

<style lang="scss">
@use "sass:math";
$DOL_TREE_MIND_BORDER: #d9d9d9;
$DOL_TREE_MIND_BORDER_WIDTH: 2px;
$empty: 30px;
$empty_3: math.div($empty, 3);

.dol-mind{
  .dol-mind-node {
    display: flex;
    align-items: center;
    padding: 6px 0;

    .block {
      margin: 10px $empty_3 10px 0;
      position: relative;

      &:after {
        content: '';
        height: $DOL_TREE_MIND_BORDER_WIDTH;
        width: $empty_3;
        position: absolute;
        right: -$empty_3;
        top: 50%;
        background: $DOL_TREE_MIND_BORDER;
      }
    }

    .dol-mind__toggle-switch{
      background: #359EF6;
      color: #FFFFFF;
      width: 14px;
      height: 14px;
      line-height: 14px;
      text-align: center;
      border-radius: 50%;
      cursor: pointer;
      font-size: 10px;
    }

    &.dol-mind-node__border{
      .block{
        border: $DOL_TREE_MIND_BORDER_WIDTH solid $DOL_TREE_MIND_BORDER;
        border-radius: 10px;
      }
    }

    .dol-mind-node {
      padding-left: $empty;
      position: relative;

      &:before {
        content: '';
        width: $empty;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        border-style: solid;
        border-color: $DOL_TREE_MIND_BORDER;
        border-width: 0 0 0 $DOL_TREE_MIND_BORDER_WIDTH;
      }

      &:first-child {
        &:before{
          top: 50%;
          border-width: $DOL_TREE_MIND_BORDER_WIDTH 0 0 $DOL_TREE_MIND_BORDER_WIDTH;
          border-radius: 10px 0 0 0;
        }

        > .block{
          &:before{
            content: none;
          }
        }
      }

      &:last-child {
        &:before{
          bottom: 50%;
          border-width: 0 0 $DOL_TREE_MIND_BORDER_WIDTH $DOL_TREE_MIND_BORDER_WIDTH;
          border-radius: 0 0 0 10px;
        }

        > .block{
          &:before{
            content: none;
          }
        }
      }

      .block {
        &:before {
          content: '';
          height: $DOL_TREE_MIND_BORDER_WIDTH;
          width: $empty;
          position: absolute;
          left: -$empty;
          top: 50%;
          background: $DOL_TREE_MIND_BORDER;
        }
      }
    }

    &.dol-mind-node__last-node {
      .block {
        &:after {
          content: none;
        }
      }
    }
  }
}
</style>
